import { render, staticRenderFns } from "./childTemplate.vue?vue&type=template&id=58773d9b&scoped=true&"
import script from "./childTemplate.vue?vue&type=script&lang=js&"
export * from "./childTemplate.vue?vue&type=script&lang=js&"
import style0 from "./childTemplate.vue?vue&type=style&index=0&id=58773d9b&prod&lang=scss&scoped=true&"
import style1 from "./childTemplate.vue?vue&type=style&index=1&id=58773d9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58773d9b",
  null
  
)

export default component.exports